import { render } from "./DireccionSucursal.vue?vue&type=template&id=47e96114"
import script from "./DireccionSucursal.vue?vue&type=script&lang=js"
export * from "./DireccionSucursal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__